import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Aboutsection.css";
import aboutTeamImg from "../../assests/about-team.png";

const FEATURES = [
  "Web & Mobile Application Solutions",
  "AI & Automation Services",
  "Digital Transformation Solutions",
  "Business Process Automation",
  "Technical Consulting & Support",
];

export default function AboutSection() {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const handleLearnMore = () => {
    navigate("/services");
  };

  return (
    <section className={`about-section${visible ? " about-visible" : ""}`} ref={sectionRef}>
      <div className="about-inner">

        {/* Left: Photo with decorative shape + dots + stat badges */}
        <div className="about-visual">
          <div className="about-visual__dots" aria-hidden="true" />
          <div className="about-visual__shape" aria-hidden="true" />

          <img
            className="about-visual__img"
            src={aboutTeamImg}
            alt="SkillSync Pro team collaborating in the office"
            loading="lazy"
          />

          <div className="about-badge badge-top-left">
           
            <span>📍</span>
            <span className="badge-text">Nagercoil, TN</span>
          </div>

          <div className="about-badge badge-bottom-left">
            <span>🏆</span>
            <span className="badge-text">75+ Placements</span>
            <span className="badge-sep" />
            <span>🤝</span>
            <span className="badge-text">28+ Partners</span>
          </div>
        </div>

        {/* Right: Content */}
        <div className="about-content">
          <h2 className="about-heading">
            Building Careers<br />
            &amp;<br />
            <span className="about-heading-accent">Digital Products</span>
          </h2>
          <p className="about-body">
            SkillSync Pro Pvt Ltd is Nagercoil's fast-growing IT solutions and software development company. We help businesses transform ideas into innovative digital solutions through cutting-edge technology, custom software development, and scalable digital products.
          </p>

          <ul className="about-features">
            {FEATURES.map((f, i) => (
              <li key={f} className="about-feature-item" style={{ animationDelay: `${0.3 + i * 0.1}s` }}>
                <span className="feature-check">
                  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 10.5l3.5 3.5L16 6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                {f}
              </li>
            ))}
          </ul>

          <button className="about-cta" onClick={handleLearnMore}>
            Learn More <span className="cta-arrow">→</span>
          </button>
        </div>

      </div>
    </section>
  );
}